import 'keen-slider/keen-slider.min.css';
import KeenSlider from 'keen-slider';

export const Carousel = (() => {
    'use strict';

    let carousels,
        cardTitles;

    function init() {
        carousels = document.querySelectorAll('.pxblock--carousel');
        cardTitles = document.querySelectorAll('.card__title');
        if(!carousels) return;
        initCarousels();

        if(cardTitles.length){
            initCardEvents();
        }
    }

    function initCarousels() {
        carousels.forEach((carousel) => {
            const sliderEl = carousel.querySelector('.keen-slider');

            const slider = new KeenSlider(sliderEl, {
                loop: true,
                slides: {
                    perView: 1.3,
                    spacing: sliderEl.dataset.spacing ?? 0,
                },
                breakpoints: {
                    '(min-width: 768px)': {
                        slides: {
                            perView: 2,
                            spacing: sliderEl.dataset.spacing ?? 0,
                        },
                    },
                    '(min-width: 1200px)': {
                        slides: {
                            perView: sliderEl.dataset.perView ?? 1,
                            spacing: sliderEl.dataset.spacing ?? 0,
                        },
                    },
                },
            });

            carousel.querySelector('.prev')?.addEventListener('click', () => slider.prev());
            carousel.querySelector('.next')?.addEventListener('click', () => slider.next());
        });
    }

    function initCardEvents() {
        cardTitles.forEach((title) => {
            let card = title.closest('.card');
            let icon = card.querySelector('.card__icon');

            title.addEventListener('click', () => {
                if(card.classList.contains('active')){
                    card.classList.remove('active');
                    icon.classList.remove('arrow-up')
                    icon.classList.add('arrow-down');
                } else {
                    card.classList.add('active');
                    icon.classList.remove('arrow-down');
                    icon.classList.add('arrow-up');
                }
            });    
        });
    }

    return {
        init: init,
    };
})();